import Dashboard from './pages/Dash.svelte';
import Login from './pages/Login.svelte';
import Shipment from './pages/Shipment.svelte';
import Products from './pages/Products.svelte';
import MyProducts from './pages/MyProducts.svelte';
import Categories from './pages/Categories.svelte';
import Categories2 from './pages/Categories2.svelte';
import Integrations from './pages/Integrations.svelte';
import Orders from './pages/Orders.svelte';
import Shipments from './pages/Shipments.svelte';
import Returns from './pages/Returns.svelte';
import Payments from './pages/Payments.svelte';
import Customers from './pages/Customers.svelte';
import Customer from './pages/Customer.svelte';


const mainRoutes = {

    '/customers/:customer_id' : Customer,

    '/customers' : Customers,

    '/payments' : Payments,

    '/returns' : Returns,

    '/shipments' : Shipments,

    '/orders' : Orders,

    '/categories' : Categories,

    '/categories2' : Categories2,

    '/dashboard' : Products,

    '/login' : Login,

    '/products/' : Products,

    '/my_products/' : MyProducts,

    '/integrations/' : Integrations,

    '/products/:page/' : Products,

    '/shipment/' : Products,

    '/shipment/:shipment_id' : Products,
    
    '*' : Products,
}

export default mainRoutes;